import axios from 'axios';

const instance = axios.create({
    baseURL : "https://api.themoviedb.org/3"
    // let dta = await fetch(baseURL)

});

// instance.get('/foo-bar');

export default instance